/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { IMSId } from 'src/app/_model/ims-object';
import { OrderItem } from 'src/app/_model/order-item';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class OrderItemsDaoService implements Resetable {
  public abstract saveOrderItems(orderItems: OrderItem[]): Promise<void>;
  public abstract getOrderItems(): Promise<OrderItem[]>;
  public abstract createOrderItem(orderItem: OrderItem): Promise<OrderItem>;
  public abstract deleteLocalOrderItem(id: IMSId): Promise<void>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}